<template>
  <div class="container">
    <CommonFrame 
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
    >
      <div slot="info">
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="tableInfo">
        <div class="cardContainer">
          <lk-card title="申请内容">
            <returnProfit
              :formObject="applyObject"
              :fieldData="drugInfo"
              :config="returnProfitContents"
            ></returnProfit>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
  </div>
</template>

<script>
import axios from 'axios';
import CommonFrame from '../commonFrame.vue';
import utils from '../../../libs/utils';
import returnProfit from '../../../components/returnProfitDetail.vue';

export default {
  name: 'Breakage',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
    returnProfit,
  },
  data() {
    return {
      drugInfo: {},
      applyObject: {},
      workNo: '',
      node: '',
      returnProfitContents: [
        [
          {
            type: 'span',
            title: '门店',
            key: 'storeName'
          },
          {
            type: 'span',
            title: '供应商',
            key: 'supplierName'
          },
        ],
        [
          {
            type: 'inputSearch',
            isShowInputSearch: false,
            title: '申请商品',
            value: '',
            showFields: [
              {
                title: '商品编码：',
                key: 'serialCode'
              },
              {
                title: '通用名：',
                key: 'approvedName'
              },
              {
                title: '商品名：',
                key: 'goodsName'
              },
              {
                title: '规格：',
                key: 'spec'
              },
              {
                title: '包装单位：',
                key: 'minPkgUnitName'
              },
              {
                title: '生产厂家：',
                key: 'producer'
              },
            ]
          }
        ],
        [
          {
            type: 'span',
            title: '验收单号',
            key: 'inspectionCode'
          },
          {
            type: 'span',
            title: '返利方式',
            key: 'rebateWay'
          },
        ],
        [
          {
            type: 'span',
            title: '返利金额',
            key: 'rebateAmount'
          },
          {
            type: 'upload',
            title: '审批附件',
            isCanEdit: false,
            uploadInfo: [
              {
                appendixName: '',
                appendixUrl: '',
              },
            ]
          },
        ],
        [
          {
            type: 'span',
            title: '申请备注',
            key: 'remark'
          },
        ]
      ],
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '其他返利录入审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
    };
  },
  methods: {
    getInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        let data = res.data.data;
        this.infosArr = data.infos;
        this.drugInfo = data.financeRebateRecordInfoVo;
        this.returnProfitContents[1][0].value = data.financeRebateRecordInfoVo.serialCode;
        this.returnProfitContents[3][1].uploadInfo = data.bizExtraVos;
        this.applyObject = data.financeRebateRecordInfoVo;
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.getInfo(this.approvalParams.businessUrl);
  },
};
</script>
